export const environment = {
  production: false,
  apiUrl: "https://rtm-cpm-api.dev.sla03.devtest.aws.scania.com/api",
  urlLogin: "https://rtm-cpm.dev.sla03.devtest.aws.scania.com/",
  apiScope: 'api://7059ab5c-1b6a-4a5f-9897-ac711453e7d6/rtm-cpm',
  graphServicePrincipalId: '74101b51-916f-4511-9a05-11d40768d6b1',
};
